import { useState, useEffect } from "react";
import { useFlow } from "@/lib/store";

function useNodeField<T>(
  nodeId: string,
  fieldName: string,
  initialValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [field, setField] = useState<T>(initialValue);
  const { updateNodeField } = useFlow();

  useEffect(() => {
    updateNodeField(nodeId, fieldName, field);
  }, [field]);

  return [field, setField];
}

export default useNodeField;
